import React from "react";

const About = () => {
  return (
    <div className="container mt-4">
      <h2>About iNotebook</h2>

      <p className="mt-3">
        <strong>iNotebook</strong> is a MERN stack based notes application
        where users can securely create, read, update and delete their
        personal notes.
      </p>

      <p>
        This application uses <strong>JWT authentication</strong> to ensure
        that only logged-in users can access their notes. Each user’s data
        is completely private and stored securely in the database.
      </p>

      <h4 className="mt-4">Technologies Used</h4>
      <ul>
        <li><strong>Frontend:</strong> React.js (Context API, React Router)</li>
        <li><strong>Backend:</strong> Node.js, Express.js</li>
        <li><strong>Database:</strong> MongoDB</li>
        <li><strong>Authentication:</strong> JWT (JSON Web Token)</li>
      </ul>

      <h4 className="mt-4">Key Features</h4>
      <ul>
        <li>User Signup & Login</li>
        <li>Protected Routes</li>
        <li>Add, Edit & Delete Notes</li>
        <li>User-specific Notes</li>
        <li>Dynamic Alert System</li>
      </ul>

      <p className="mt-3">
        This project is built as a part of learning full-stack web
        development using the MERN stack and follows best practices for
        authentication and state management.
      </p>
    </div>
  );
};

export default About;
